import { ApiListActionOriginResponse } from '../../../api/core/models';
import { BoardSettingsV2 } from '../model';

export function apiBoardSettingsToActionOrigins(
  actionOriginsResponse?: ApiListActionOriginResponse
): BoardSettingsV2['actionOrigins'] {
  if (!actionOriginsResponse?.action_origins) {
    return [];
  }

  return actionOriginsResponse.action_origins.map((actionOrigin) => ({
    id: actionOrigin.id!,
    title: actionOrigin.title!,
    description: actionOrigin?.description ?? '',
    type: actionOrigin.type!,
  }));
}
